export const hasEliteMatrixSelection = (row = {}, decoratorDetails = {}, rowIndex = null) => Boolean(
  row.chargeId ?? row.ChargeId ??
  (rowIndex == null ? (decoratorDetails.chargeId ?? decoratorDetails.ChargeId) : null) ??
  (Array.isArray(decoratorDetails.rowBindings)
    && decoratorDetails.rowBindings.some((binding) =>
      (rowIndex == null || Number(binding?.rowIndex ?? binding?.RowIndex) === Number(rowIndex))
      && Boolean(binding?.chargeId ?? binding?.ChargeId)))
);

export const isEliteChargeNameReadOnly = ({ source, row, decoratorDetails, rowIndex = null, manualOverride = false }) =>
  String(source || '').trim().toLowerCase() === 'elite'
  && !hasEliteMatrixSelection(row, decoratorDetails, rowIndex)
  && !manualOverride;
